
import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  // Disable browser automatic scroll restoration to avoid random scroll restoration points
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      try {
        window.history.scrollRestoration = 'manual';
      } catch (e) {}
    }
  }, []);

  const resetScroll = () => {
    // 1. Scroll main window
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });

    // 2. Scroll document elements
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }

    // 3. Scroll any internal scrollable wrappers (e.g. dashboard containers, main, #root)
    const scrollContainers = document.querySelectorAll<HTMLElement>(
      '#root, main, .sz-page-container, .sz-dashboard-root, [data-scroll-container]'
    );
    scrollContainers.forEach(container => {
      if (container && container.scrollTop > 0) {
        container.scrollTop = 0;
      }
    });
  };

  useLayoutEffect(() => {
    resetScroll();

    // Re-verify on next frame and after lazy-loaded routes finish rendering
    const rafId = requestAnimationFrame(resetScroll);
    const timerId = setTimeout(resetScroll, 50);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timerId);
    };
  }, [pathname, search, hash]);

  return null;
};

